export default __webpack_public_path__ + "static/media/3167.42bcdcbd.svg";